import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const actions = {
  sendEmailAuth(context, { username, password } = {}) {
    console.log('sending...');
    return axios
      .post(`${serverUrl}/a2f/email/sent-msg/`, { email: username, password })
      .then((response) => {
        return response.data;
      })
  },

  async fetchQR(context) {
    return axios
      .get(`${serverUrl}/a2f/totp/`)
      .then((response) => {
        return response.data;
      })
  },

  async activateTotpAuth(context, code) {
    try {
      await axios.post(`${serverUrl}/a2f/totp/verify/`, { code })
      return { error: null, isValid: true }
    } catch (error) {
      return { error: error, isValid: false }
    }
  },

  async deleteTotpAuth(context) {
    return axios
      .delete(`${serverUrl}/a2f/totp/`)
      .then((response) => {
        return response.data;
      })
  },

  async activateEmailAuth(context) {
    return axios
      .post(`${serverUrl}/a2f/email/`)
      .then((response) => {
        return response.data;
      })
  },

  async deleteEmailAuth(context) {
    return axios
      .delete(`${serverUrl}/a2f/email/`)
      .then((response) => {
        return response.data;
      })
  },

  async fetchAuthDevices(context) {
    return axios
      .get(`${serverUrl}/a2f/devices/`)
      .then((response) => {
        return response.data.devices;
      })
  },
}